
import { FC, useState } from "react";

// Define the shape of reaction data
type ReactionCounts = Record<string, number>;

// Define types
type UserReaction = { type: string }; // Example: { type: 'like' }

interface ReactionsProps {
  totalReactions: ReactionCounts; // Total counts for each reaction type
  userReactions: UserReaction[] | null; // Logged-in user's reactions
  onReact: (type: string, add: boolean) => void; // Callback to add/remove reactions
}

export const reactionTypes: { type: string; label: string; icon: string }[] = [
    { type: "like", label: "Like", icon: "👍" },
    { type: "love", label: "Love", icon: "❤️" },
    { type: "helpful", label: "Helpful", icon: "🤝" },
    { type: "informative", label: "Informative", icon: "📚" },
    { type: "dislike", label: "Dislike", icon: "👎" },
  ];

const Reactions: FC<ReactionsProps> = ({ 
    totalReactions,
    userReactions,
    onReact,
}) => {
  const [isOpen, setIsOpen] = useState(false); // Controls pop-out visibility
  const [selectedReaction, setSelectedReaction] = useState<string | null>(null);

  const [selectedReactions, setSelectedReactions] = useState<Set<string>>(
    new Set(userReactions?.map((reaction) => reaction.type))
  );

  const handleReaction = (type: string) => {
    const isSelected = selectedReactions.has(type);
    const updatedReactions = new Set(selectedReactions);

    if (isSelected) {
      updatedReactions.delete(type);
    } else {
      updatedReactions.add(type);
    }

    setSelectedReactions(updatedReactions);
    onReact(type, !isSelected); // Add or remove reaction
  };

  return (
    <div className="flex gap-4 items-center">
      {reactionTypes.map((reaction) => (
        <button
          key={reaction.type}
          onClick={() => handleReaction(reaction.type)}
          disabled={!userReactions}
          title={`${reaction.label} (${!userReactions ? "Login to react" : "Click to react"})`}
          className={`flex items-center gap-2 px-3 py-1 border rounded-md shadow-sm transition ${
            selectedReactions.has(reaction.type)
              ? "bg-muted hover:bg-red-100"
              : "hover:bg-green-100"
          }`}
        >
          <span>{reaction.icon}</span>
          <span className="">{totalReactions[reaction.type] || 0}</span>
        </button>
      ))}
    </div>
  );

//   const [userReactions, setUserReactions] = useState<ReactionCounts>(reactions);




//   const handleReaction = (type: string) => {
//     setSelectedReaction(type);
//     setIsOpen(false); // Close the pop-out after a reaction is selected
//     onReact(type);
//   };

//   return (
//     <div className="relative flex items-center justify-center">

//         <div className="flex gap-4 items-center">
//         {reactionTypes.map((reaction) => (
//             <button
//             key={reaction.type}
//             title={reaction.label}
//             onClick={() => handleReaction(reaction.type)}
//             className="flex items-center gap-1 px-3 py-1 border rounded-md shadow-sm hover:bg-gray-100 transition"
//             >
//             <span>{reaction.icon}</span>
//             <span className="text-sm text-gray-600">
//                 {userReactions[reaction.type] || 0}
//             </span>
//             </button>
//         ))}
//         </div>

//       {/* Main button to trigger the pop-out */}
//       <button
//         onClick={() => setIsOpen((prev) => !prev)}
//         className="flex items-center justify-center w-12 h-12 rounded-full shadow-md"
//       >
//         {selectedReaction ? (
//           <span className="text-xl">
//             {reactionTypes.find((r) => r.type === selectedReaction)?.icon}
//           </span>
//         ) : (
//           "React"
//         )}
//       </button>

//       {/* Pop-out options */}
//       {isOpen && (
//         <div className="absolute top-[-3.5rem] flex gap-2 bg-white shadow-lg rounded-full p-2">
//           {reactionTypes.map((reaction) => (
//             <button
//               key={reaction.type}
//               onClick={() => handleReaction(reaction.type)}
//               className="flex items-center justify-center w-10 h-10 bg-gray-100 rounded-full hover:bg-gray-200 transition"
//               title={reaction.label}
//             >
//               <span className="text-xl">{reaction.icon}</span>
//             </button>
//           ))}
//         </div>
//       )}
//     </div>
//   );
};

export default Reactions;